// extracted by mini-css-extract-plugin
export default {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#58406e","menuHover":"#58406e","subMenuBg":"#58406e","subMenuHover":"#58406e","sideBarWidth":"210px"};